var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Container',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4 col-xl-3 d-lg-block d-none"},[_c('MoreLinks')],1),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-xl-9"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }